import React from "react";
import "./style.css";
import { lifeAtBitsclanData } from "../../data/lifeAtBitsclanData";
import { useTranslation } from "react-i18next";
import TrustedPartner from "../trustedPartners/TrustedPartner";

const LifeBanner = () => {
  const { t } = useTranslation("lifeAtBitsclan");

  // Get translated projects array
  const banner = t("banner", { returnObjects: true });
  return (
    <>
      {/* <div className="life-at-bitsclan-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="life-banner-box">
                <h1>
                  {banner?.heading} <span>{banner?.subHeading}</span>
                </h1>
                <p className="common-text">{banner?.paragraphOne}</p>

                <p className="common-text">{banner?.paragraphTwo}</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="life-at-bitsclan-new-banner-top-section">
        <div className="container">
          <div class="row">
            <div class="col-md-12 text-center text-md-start">
              <h1 className="low-top-heading">Our Identity</h1>
              <p class="display-5 fw-bolder life-at-bitsclan-title">Your Growth Partner</p>
              <p className="description-text">Trusted by Fortune 500s, enterprises & startups worldwide</p>
            </div>
          </div>
        </div>
      </div>

      {/* <TrustedPartner/> */}

      <div className="life-at-bitsclan-new-banner-box">
        <section class="life-at-bitsclan-new-banner-section">
          <div class="container life-at-bitsclan-container">
            <div class="row align-items-center">
              <div class="col-xl-7 col-lg-7 col-md-6 mb-4 mb-md-0 text-center text-md-start">
                <h2 class="life-at-bitsclan-highlight">
                  We work as <span>One!</span>
                </h2>
                <p class="life-at-bitsclan-text">
                  Innovation is our foundation, AI is our edge, & launching &
                  scaling digital products is our passion. At Bitsclan IT Solutions, we
                  blend software development, AI solutions, cloud services, & IT
                  consulting to help businesses grow faster & smarter.
                </p>
              </div>
              <div class="col-lg-5 col-md-6 text-center text-md-start">
                <div class="life-at-bitsclan-list-container d-flex flex-column align-items-center align-items-md-start">
                  <h4 class="mb-3 fw-bold life-at-bitsclan-list-title">
                    Our People Make Technology Happen
                  </h4>
                  <ul class="list-unstyled life-at-bitsclan-list-items">
                    <li>
                      <span class="life-at-bitsclan-list-dot"></span>
                      <span className="life-at-bitsclan-banner-list-text">Designers crafting seamless digital experiences</span>
                    </li>
                    <li>
                      <span class="life-at-bitsclan-list-dot"></span>
                      <span className="life-at-bitsclan-banner-list-text">Developers building enterprise-grade systems</span>
                    </li>
                    <li>
                      <span class="life-at-bitsclan-list-dot"></span>
                      <span className="life-at-bitsclan-banner-list-text">AI & Cloud Experts driving automation & scale</span>
                    </li>
                    <li>
                      <span class="life-at-bitsclan-list-dot"></span>
                      <span className="life-at-bitsclan-banner-list-text">QAs ensuring precision & performance</span>
                    </li>
                    <li>
                      <span class="life-at-bitsclan-list-dot"></span>
                      <span className="life-at-bitsclan-banner-list-text">Consultants & Strategists unlocking business growth</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 remove-small-screes">
                <img src="/images/life-at-bitsclan/mouse.svg" alt="CEO Image" style={{ position: 'absolute', bottom: '3rem', insetInlineEnd: '2rem', zIndex: 9, width: '20%', }} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LifeBanner;
